import * as NoteField from './note/field';

export enum Operation {
  Append = 'APPEND',
  Prepend = 'PREPEND',
  Replace = 'REPLACE',
}

export interface TemplateIdentifier {
  id: string;
  name: string;
  section: NoteField.Section | null;
  provider_user_id: string;
  organization_ids: string[];
}

export interface TemplateSelector {
  id: string;
  noteId: string;
}

export interface TemplateFull {
  id: string;
  name: string;
  provider_user_id: string;
  organization_ids: string[];
  section: NoteField.Section | null;
  version: number;
}

export interface TemplateField {
  cpt_codes: unknown;
  dynamic_value_configs: DynamicValueConfig[] | null;
  key: string;
  section: NoteField.Section | null;
  note_field: string;
  note_value: string;
  standard_note_field_id: string | null;
  operation: Operation;
  placement: number;
  parameters: TemplateFieldParameter[] | null;
  template_id: string;
  template_name: string;
  version: number;
}

export interface DynamicValueConfig {
  name: string;
  outputs?: { [input: string]: string };
  required: boolean;
  form_template_field_config_id: string | null;
}

export interface TemplateFieldParameter {
  name: string;
  primitive_type: NoteField.Primitive;
  default_value: string;
  options: string[] | null;
  range: [number, number, number] | null;
  prefix: string | null;
  suffix: string | null;
  required: boolean;
}

// used by /compile
enum Kind {
  Template = 'TEMPLATE',
  Field = 'FIELD',
}
export interface TemplateFieldParameterCompiled {
  name: string;
}
export interface TemplateFieldCompiled {
  cptCodes: unknown;
  kind: Kind;
  noteField: string;
  noteValue: string;
  parameters: TemplateFieldParameterCompiled[] | null;
  section: NoteField.Section | null;
  standard_note_field_id: string | null;
  subsection: string | null;
  operation: Operation;
  placement: number;
}

export interface DetailsResponse {
  template: TemplateFull;
  fields: TemplateField[];
  scenarios: {}[];
  form_template_id: string | null;
}

export interface CreateUpdateTemplateValues {
  name: string;
  provider_user_id: string;
}

export interface CreateUpdateDynamicValueConfig {
  name: string;
  outputs: { [input: string]: string };
  required: boolean;
  form_template_field_config_id: string | null;
}

export interface CreateUpdateTemplateFieldValues {
  dynamic_value_configs: CreateUpdateDynamicValueConfig[];
  key: string | null;
  note_field: string;
  note_value: string;
  section: NoteField.Section | string;
  standard_note_field_id: string | null;
  operation: Operation;
  placement: number;
}

export interface CreateUpdateValues {
  template: CreateUpdateTemplateValues;
  fields: CreateUpdateTemplateFieldValues[];
}

export const commonNoteDynamicValues = [
  'first_name',
  'last_name',
  'gender_pronoun',
  'sex',
  'gender_title',
  'gender_pronoun_subject',
  'gender_pronoun_subject_capitalized',
  'gender_pronoun_object',
  'gender_pronoun_object_capitalized',
  'gender_pronoun_possessive',
  'gender_pronoun_possessive_capitalized',
  'gender_adjective_possessive',
  'gender_adjective_possessive_capitalized',
  'age',
  'height',
  'height_metric',
  'height_customary',
  'weight',
  'weight_metric',
  'weight_customary',
  'body_mass_index',
  'chief_complaints',
  'chief_complaints_with_comments',
  'follow_up',
  'carry_forward_hpi',
  'carry_forward_exam',
  'carry_forward_ros',
  'carry_forward_ap',
  'carry_forward_patient_instructions',
  'carry_forward_discussion_notes',
  'carry_current_hpi',
  'carry_current_exam',
  'carry_current_ros',
  'carry_current_ap',
  'carry_current_patient_instructions',
  'carry_current_discussion_notes',
  'blood_pressure_systolic',
  'blood_pressure_diastolic',
  'blood_pressure_source',
  'blood_pressure_patient_position',
  'blood_pressure_patient_cuff_size',
  'heart_rate',
  'body_temperature_celsius',
  'body_temperature_source',
  'respiratory_rate',
  'peak_flow_liters_per_minute',
  'oxygen_saturation_percentage',
  'problems_and_orders',
  'diagmed',
  'last_menstrual_period_date',
  'last_menstrual_period_comment',
  'breastfeeding_status',
  'breastfeeding_comment',
  'gptal_score',
  'gestational_age',
];
